import { render, staticRenderFns } from "./TabIndex.vue?vue&type=template&id=02cc50b0"
import script from "./TabIndex.vue?vue&type=script&lang=ts"
export * from "./TabIndex.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports